;(function(){

	var $homeWrapper = $('#home-container'),
		$road = $('.road')

	//Animates the van when entering viewport
	if($homeWrapper.length > 0) {
		$road
			.cleverScroll({
				useOnce: false,
				offset: site.height / 8,
				ready: function($el){
					//animates the van
				},
				onEnterViewport: function($el){
					$el.addClass('active');
				},
				onLeaveViewport: function($el){
					$el.removeClass('active');
				}
			});

	}

}());
